import React from 'react';
import { Button, Stack } from '@moda/om';
import { PageFilterFragment } from '../../generated/types/PageFilterFragment';
import { useCategoryTree } from '../../hooks/useCategoryTree';
import { usePLPParams } from '../../hooks/usePLPParams';

import './SubcategoryLinks.scss';

export const MIN_NUM_OF_PRODUCTS_PER_SUBCATEGORY = 10;
export const MAX_NUM_OF_LINKS = 5;

type Props = {
  categoryTree: PageFilterFragment['categoryTree'];
  designerName: string;
};

export const SubcategoryLinks: React.FC<Props> = ({ categoryTree, designerName }) => {
  const {
    params: { category, subcategory }
  } = usePLPParams();
  const { activeCategoryNode, getCategoryNodeHref } = useCategoryTree(categoryTree);

  const subcategories = (activeCategoryNode.children || []).filter(
    item => item && item.totalItems && item.totalItems > MIN_NUM_OF_PRODUCTS_PER_SUBCATEGORY
  );

  if (!category) return null;
  if (subcategory) return null;

  return (
    <Stack
      alignItems="center"
      direction="horizontal"
      justifyContent="space-evenly"
      space={0}
      className="SubcategoryLinks"
    >
      {subcategories.slice(0, MAX_NUM_OF_LINKS).map(
        (item, index) =>
          item && (
            <Button
              secondary
              to={getCategoryNodeHref(item) || ''}
              className="SubcategoryLinks__button"
              key={index}
            >
              {`${designerName} ${item?.name}`}
            </Button>
          )
      )}
    </Stack>
  );
};
